import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NvTooltipComponent } from './nv-tooltip.component';
import { NvTooltipDirective } from './nv-tooltip.directive';
import { NvTooltipDataService } from './nv-tooltip.service';
@NgModule({
  declarations: [NvTooltipComponent, NvTooltipDirective],
  providers: [NvTooltipDataService],
  entryComponents: [NvTooltipComponent],
  imports: [OverlayModule, CommonModule],
  exports: [NvTooltipDirective],
})
export class NvTooltipModule {}
